// Generated by scripts/write-build-info.js before every build — do not edit.
export const BUILD_STAMP = "2026-10-06 09:15";
export const BUILD_SHA = "e3785b2";
